import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Menu, X, ChevronDown } from 'lucide-react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from '../../services/firebase/config';
import { signOut } from 'firebase/auth';

const navItems = [
  { title: 'AnaSayfa', path: '/' },
  {
    title: 'Eğitim',
    children: [
      { title: 'Rehber', path: '/egitim' },
      { title: 'Temel Bilgiler', path: '/egitim/temel-egitimler' },
       
    ]
  },
  /* Geçici olarak kapatıldı
  {
    title: 'Piyasalar',
    children: [
      { title: 'En Cok Kazanan Hisseler', path: '/piyasalar/en-cok-kazananlar' },
      { title: 'En Cok Kaybeden Hisseler', path: '/piyasalar/en-cok-kaybedenler' },
      { title: 'En Yuksek Hacimliler', path: '/piyasalar/en-yuksek-hacimliler' },
      { title: 'Sektor Performanslari', path: '/piyasalar/sektor-performanslari' },
      { title: 'Kripto Paralar', path: '/piyasalar/kriptopara' },
      { title: 'Doviz Kurlari ', path: '/piyasalar/doviz-kurlari' },

    ]
  },
  { title: 'Haberler', path: '/global-haberler' },
  */
  { title: 'Abonelik', path: '/membership' }
];

const HeaderPublic = () => {
  const [user] = useAuthState(auth);
  const navigate = useNavigate();
  const [openDropdown, setOpenDropdown] = useState(null);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    document.documentElement.classList.add('dark');
    localStorage.setItem('darkMode', 'true');
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.dropdown-container')) {
        setOpenDropdown(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate('/login');
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  const handleDropdownClick = (title) => {
    setOpenDropdown(openDropdown === title ? null : title);
  };

  const renderNavItems = (isMobile = false) => {
    return navItems.map((item, index) => {
      if (item.children) {
        const isOpen = openDropdown === item.title;

        return (
          <div 
            key={index} 
            className={`dropdown-container ${isMobile ? 'py-2' : 'relative'}`}
          >
            <button
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                handleDropdownClick(item.title);
              }}
              className={`flex items-center space-x-1 ${
                isMobile 
                  ? 'w-full text-gray-300' 
                  : 'text-gray-300 hover:text-white'
              }`}
            >
              <span>{item.title}</span>
              <ChevronDown 
                size={16}
                className={`transform transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} 
              />
            </button>

            {isOpen && (
              <div 
                className={`${
                  isMobile 
                    ? 'pl-4 mt-2 space-y-2' 
                    : 'absolute z-50 left-0 mt-2 w-64 rounded-md shadow-lg bg-[#151934] ring-1 ring-black ring-opacity-5'
                }`}
                onClick={(e) => e.stopPropagation()}
              >
                {item.children.map((child, childIndex) => (
                  <Link
                    key={childIndex}
                    to={child.path}
                    className={`block ${
                      isMobile
                        ? 'py-2 text-gray-300 hover:text-white'
                        : 'px-4 py-2 text-sm text-gray-300 hover:bg-gray-800 hover:text-white'
                    }`}
                    onClick={() => {
                      setOpenDropdown(null);
                      if (isMobile) setIsMobileMenuOpen(false);
                    }}
                  >
                    {child.title}
                  </Link>
                ))}
              </div>
            )}
          </div>
        );
      }

      return (
        <Link
          key={index}
          to={item.path}
          className={`${
            isMobile
              ? 'block py-2 text-gray-300 hover:text-white'
              : 'text-gray-300 hover:text-white'
          }`}
          onClick={() => isMobile && setIsMobileMenuOpen(false)}
        >
          {item.title}
        </Link>
      );
    });
  };

  return (
    <header className="fixed w-full z-50 bg-[#151934] border-b border-gray-700/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
            <Link to="/" className="flex items-center">
              <img src="/splogo_192_p.png" alt="Smart-Portfoy Logo" className="h-8 w-auto" />
              <span className="text-xl font-bold text-white ml-3">
                Smart Portfoy
              </span>
            </Link>
            <nav className="hidden md:flex space-x-8 ml-10">
              {renderNavItems()}
            </nav>
          </div>

          <div className="flex items-center space-x-4">
            <div className="hidden md:flex items-center space-x-4">
              {user ? (
                <button
                  onClick={handleLogout}
                  className="bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700"
                >
                  Çıkış Yap
                </button>
              ) : (
                <>
                  <Link to="/login" className="text-gray-300 hover:text-white">
                    Giriş Yap
                  </Link>
                  <Link to="/register" className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700">
                    Kayıt Ol
                  </Link>
                </>
              )}
            </div>

            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="md:hidden p-2 text-gray-300 hover:text-white"
            >
              {isMobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>

        {isMobileMenuOpen && (
          <div className="md:hidden py-4">
            {renderNavItems(true)}
            <div className="pt-4 border-t border-gray-700">
              {user ? (
                <button
                  onClick={() => {
                    handleLogout();
                    setIsMobileMenuOpen(false);
                  }}
                  className="block w-full text-left py-2 text-gray-300 hover:text-white"
                >
                  Çıkış Yap
                </button>
              ) : (
                <>
                  <Link
                    to="/login"
                    className="block py-2 text-gray-300 hover:text-white"
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    Giriş Yap
                  </Link>
                  <Link
                    to="/register"
                    className="block py-2 text-gray-300 hover:text-white"
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    Kayıt Ol
                  </Link>
                </>
              )}
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default HeaderPublic;